import React from "react";
import cx from "classnames";
import "./Card.scss";
import { Spinner } from "../spinner/Spinner";
import { AnimatePresence, motion } from "framer-motion";
export function Card({ id, children, className, style, toned, showLoading = false, }) {
    const classes = cx(className, "card", {
        toned,
    });
    if (toned) {
        return (React.createElement("div", { id: id, className: classes, style: style },
            React.createElement("div", { className: "card-bg" },
                React.createElement("div", null),
                React.createElement("div", null)),
            React.createElement("div", { className: "card-body" }, children),
            React.createElement(AnimatePresence, null, showLoading && (React.createElement(motion.div, { className: "card-loading-wrapper", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
                React.createElement(Spinner, null))))));
    }
    else {
        return (React.createElement("div", { id: id, className: classes, style: style },
            children,
            React.createElement(AnimatePresence, null, showLoading && (React.createElement(motion.div, { className: "card-loading-wrapper", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
                React.createElement(Spinner, null))))));
    }
}
